const INTERACTIVE_ROW_ELEMENTS =
	'button, a, input, select, textarea, [role="button"], [role="checkbox"], [contenteditable="true"]';

interface IRowClickSelectionParams {
	ignoredColumns?: Array<string>;
	isEditableColumn: (columnId: string) => boolean;
	getSelectedText?: () => string;
}

export const isRowClickSelectable = (
	target: HTMLElement | null,
	{ ignoredColumns, isEditableColumn, getSelectedText }: IRowClickSelectionParams,
): boolean => {
	if (!target) return false;
	if (getSelectedText?.()) return false;
	if (target.closest(INTERACTIVE_ROW_ELEMENTS)) return false;

	const columnId = target.closest("td")?.getAttribute("data-col-id");
	if (!columnId) return true;
	if (ignoredColumns?.includes(columnId)) return false;

	return !isEditableColumn(columnId);
};
